import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibScrollableListComponent } from './lib-scrollable-list.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LibScrollableListComponent],
  exports: [LibScrollableListComponent],
})
export class LibScrollableListModule {}
